module.exports = __webpack_public_path__ + "static/img/4.d5eedd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/product/4.jpg
// module id = otNz
// module chunks = 1